import { Box, Grid } from "@mui/material";
import { Redirect, Route, Switch } from "react-router-dom";
// import rootRoutes from "routes";
import { default as Edit, default as EditPreview } from "./edit/components";
import FormsCRUD from "./formsCRUD/components";
import ResourcesCRUD from "./resourcesCRUD/components";
import buildRoutes from "./routes";

function Build() {
  return (
    <Box sx={{ height: "100%", overflowX: "hidden" }}>
      <Grid
        sx={{ height: "100%" }}
        container
        direction="column"
        wrap="nowrap"
        spacing={1}
      >
        <Grid item>
          <Box sx={(theme) => ({ ...theme.mixins.toolbar })} />
        </Grid>
        <Grid item xs height="100%" overflow="auto">
          <Switch>
            <Route exact path={buildRoutes.HOME}>
              <Redirect to={buildRoutes.FORM_DEFINITIONS} />
            </Route>
            <Route exact path={buildRoutes.FORM_DEFINITIONS}>
              <FormsCRUD />
            </Route>
            <Route path={buildRoutes.FORM_DEFINITION_PREVIEW}>
              <EditPreview />
            </Route>
            <Route path={buildRoutes.FORM_DEFINITION_EDIT}>
              <Edit />
            </Route>
            <Route path={buildRoutes.RESOURCES}>
              <ResourcesCRUD />
            </Route>
          </Switch>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Build;
